import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import bulkEnrichmentActions from '@/redux/bulkEnrichment/actions';
import modalsActions from '@/redux/modals/actions';
import { Loader } from '@/components';
import { dateToString } from '@/utils/common';
import { BulkEnrichmentStatusChoices } from '@/constants/Proposals';

const AsyncBulkEnrichment = Loadable({
  loader: () => import('./BulkEnrichment'),
  loading: Loader,
});

const mapStateToProps = ({ bulkEnrichment, modals }) => ({
  ...bulkEnrichment,
  isUploadBulkEnrichmentFileModalOpen: modals.isUploadBulkEnrichmentFileModalOpen,
  tableData: bulkEnrichment.data.map((data) => {
    return Object.assign(
      {},
      {
        key: data.id,
        id: data.id,
        name: data.name,
        file: data.file,
        status: BulkEnrichmentStatusChoices(data.status),
        requestedBy: `${data.user?.first_name} ${data.user?.last_name}`,
        uploaded: dateToString(data.submission_date),
      }
    );
  }),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchEnrichments: bulkEnrichmentActions.fetchEnrichments,
      uploadFile: bulkEnrichmentActions.uploadFile,
      deleteFile: bulkEnrichmentActions.deleteFile,
      toggleUploadBulkEnrichmentFileModal: modalsActions.toggleUploadBulkEnrichmentFileModal,
      onRemoveFile: bulkEnrichmentActions.onRemoveFile,
      beforeUpload: bulkEnrichmentActions.beforeUpload,
      setFileName: bulkEnrichmentActions.setFileName,
      tableChange: bulkEnrichmentActions.tableChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncBulkEnrichment);
